import React from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import hi from "./hi.json";
import ta from "./ta.json";
import as from "./as.json";
import bn from "./bn.json";
import gu from "./gu.json";
import mr from "./mr.json";
import or from "./or.json";
import pa from "./pa.json";
import te from "./te.json";
import ka from "./ka.json";
import ur from "./ur.json";
import ml from "./ml.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      hi: {
        translation: hi,
      },
      ta: {
        translation: ta,
      },
      as: {
        translation: as,
      },
      bn: {
        translation: bn,
      },
      gu: {
        translation: gu,
      },
      mr: {
        translation: mr,
      },
      or: {
        translation: or,
      },
      pa: {
        translation: pa,
      },
      te: {
        translation: te,
      },
      ka: {
        translation: ka,
      },
      ur: {
        translation: ur,
      },
      ml: {
        translation: ml,
      },
    },
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
